/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { ɵstringify as stringify } from "@angular/core";
/**
 * @param {?} type
 * @param {?} value
 * @return {?}
 */
export function invalidPipeArgumentError(type, value) {
    return Error("InvalidPipeArgument: '" + value + "' for pipe '" + stringify(type) + "'");
}
//# sourceMappingURL=invalid_pipe_argument_error.js.map


// WEBPACK FOOTER //
// ../../../packages/common/esm5/src/pipes/invalid_pipe_argument_error.js